// Constants
export const API_URL = 'https://stock.wizardinfosys.in/';